class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);



// test code for size guide 

//  document.addEventListener("DOMContentLoaded", function () {

//   function moveSizeGuide() {
//     const sizeGuide = document.querySelector('.ks-chart-container');
//     const label = document.querySelector('[data-option-name="Select Size & Fit"] .option-label');

//     if (sizeGuide && label && !label.contains(sizeGuide)) {
//       label.appendChild(sizeGuide); // ✅ now goes INSIDE label at end
//     }
//   }

//   moveSizeGuide();

//   const observer = new MutationObserver(moveSizeGuide);
//   observer.observe(document.body, { childList: true, subtree: true });

// });


document.addEventListener("DOMContentLoaded", function () {

  function restructureLabel() {
    const label = document.querySelector('.option-label.customspace');
    const sizeGuide = document.querySelector('.ks-chart-container');

    if (!label || !sizeGuide) return;

    // prevent running twice
    if (label.querySelector('.label-left')) return;

    const title = label.querySelector('.option-label--title');
    const selected = label.querySelector('.option-label--selected');

    // create wrappers
    const left = document.createElement('div');
    left.className = 'label-left';

    const right = document.createElement('div');
    right.className = 'label-right';

    // move existing elements
    if (title) left.appendChild(title);
    if (selected) left.appendChild(selected);

    right.appendChild(sizeGuide);

    // clear label and re-append clean structure
    label.innerHTML = '';
    label.appendChild(left);
    label.appendChild(right);
  }

  restructureLabel();

  const observer = new MutationObserver(restructureLabel);
  observer.observe(document.body, { childList: true, subtree: true });

});




// test code for size guide 
